import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withRouter } from 'react-router'
// import { profile } from 'routes/route.map'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import { InWinButtonCell } from './component'

export const MakeInWinCell = combine({
  hocs: [withRouter],
  hooks: [
    withTableController({ id: 'events-table' }),
    withContext('appStore', StoreContext),
    withCallbacks(
      {
        onRouteToUpdateEditForm:
          ({ appStore }, { value }) =>
          () => {
            // history.push(profile.makeInWins.add.view(value.id))
            appStore.appConfig.toggleDrawer(`${value.id}`)
          },
      },
      ['value']
    ),
  ],
})(InWinButtonCell)
